import { atom } from "recoil";

export interface ToastState {
  show: boolean;
  icon?: React.ReactNode;
  messages: string[];
}

const initToastState: ToastState = {
  show: false,
  icon: undefined,
  messages: ["회원가입이 완료되었습니다.", "다시 로그인 해주세요."],
};

export const toastState = atom<ToastState>({
  key: "toastState",
  default: initToastState,
});
